import { useQuery } from "react-query";
import { fetchSalesOrder, fetchSalesOrderDetail, fetchWorkOrder, getSalesOrder } from "../api/data";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableHead as TableHeadCell,
} from "../components/tabel";
import { useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import { formatDate, getStatusStyle } from "../utils";
import { FaArrowRightFromBracket } from "react-icons/fa6";
import { useEffect, useState } from "react";
import { resource } from "../api/apiRequest";

const SalesOrderList = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState(null);
  const [woSum, setWOSum] = useState({});
  const [soDetails, setSoDetails] = useState({});
  const [woData, setWOData] = useState([]);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [loadingWorkOrders, setLoadingWorkOrders] = useState(true);

  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);


  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const { data: salesOrder, isLoading: soLoading, error } = useQuery(
    ["sales-order", email],
    () => getSalesOrder({ user: email }), 
    {
      enabled: !!email, 
      onSuccess: (data) => {
        console.log("Filtered Data SO", data);
      },
    }
  );

  console.log('Sales Orders Query', salesOrder)

  useEffect(() => {
    const fetchDetails = async () => {
      if (!salesOrder?.message) {
        setLoadingDetails(false);
        return;
      }

      setLoadingDetails(true);

      try {
        const detailPromises = salesOrder.message.map(async (order) => {
          try {
            const detail = await fetchSalesOrderDetail(order.name);
            const itemsWithCustomerID = await Promise.all(
              (detail.data?.items || []).map(async (item) => {
                try {
                  const res = await resource.get(`Item/${item.item_code}`, '["custom_part_number_fg_customer"]');
                  return {
                    ...item,
                    custom_part_number_fg_customer: res.data.data.custom_part_number_fg_customer || null,
                  };
                } catch {
                  return item;
                }
              })
            );
            return {
              name: order.name,
              items: itemsWithCustomerID || [],
            };
          } catch {
            return {
              name: order.name,
              items: [],
            };
          }
        });

        const allDetails = await Promise.all(detailPromises);

        const detailsMap = {};
        allDetails.forEach((detail) => {
          detailsMap[detail.name] = detail.items;
        });

        setSoDetails(detailsMap);
      } finally {
        setLoadingDetails(false);
      }
    };

    fetchDetails();
  }, [salesOrder]);

  useEffect(() => {
    const fetchWorkOrders = async () => {
      if (!salesOrder?.message) {
        setLoadingWorkOrders(false);
        return;
      }

      setLoadingWorkOrders(true);

      try {
        const woPromises = salesOrder.message.map(order => fetchWorkOrder({ salesOrders: order.name }));
        const allWorkOrders = await Promise.all(woPromises);

        const flattenedWorkOrders = allWorkOrders.flat();
        console.log("flattenedWorkOrders",flattenedWorkOrders);

        const allWOData = flattenedWorkOrders.flatMap(woWrapper => woWrapper.data);

        const sumMap = {};
        allWOData.forEach(wo => {
          const qty = wo.produced_qty ?? wo.manufactured_qty ?? 0;
          if (!sumMap[wo.sales_order]) sumMap[wo.sales_order] = 0;
          sumMap[wo.sales_order] += qty;
        });

        setWOSum(sumMap);


      } catch (error) {
        console.error("Failed to fetch work orders", error);
      } finally {
        setLoadingWorkOrders(false);
      }
    };

    fetchWorkOrders();
  }, [salesOrder]);


  console.log("Sales Order", salesOrder?.message)

  const rowsData = salesOrder?.message
    ?.slice() 
    .sort((a, b) => new Date(b.transaction_date) - new Date(a.transaction_date)) // urut dari terbaru ke terlama
    .flatMap((order) => {
        const items = soDetails[order.name] || [];

        if (items.length === 0) {
        return [
            {
            order,
            item: null,
            noItem: true,
            },
        ];
        }

        return items.map((item) => ({
            order,
            item,
            noItem: false,
        }));
  }) || [];

  console.log("WO SUM", woSum)

  console.log("Rows Data", rowsData)
  return (
    <div className="w-full h-screen flex flex-col p-10 bg-gradient-to-b from-[#203E6F] to-[#4169E1]">
      <div className="flex justify-between w-full items-center">
        <h1 className="text-3xl font-bold text-white mb-6">Daftar Sales Order</h1>
        <div
          onClick={handleLogout}
          className="p-2 bg-white rounded-md flex items-center gap-2 cursor-pointer active:opacity-70 hover:bg-gray-100 transition"
        >
          <FaArrowRightFromBracket className="text-red-600 text-2xl" />
          <div className="text-red-600 text-lg font-semibold">Keluar</div>
        </div>
      </div>

      <div className="bg-white w-full rounded-xl shadow-lg h-screen p-6">
        <div className="bg-white w-full max-h-[80vh] overflow-y-auto no-scrollbar">
          {soLoading || loadingDetails ? (
            <div className="flex items-center justify-center h-screen w-full">
              <FaSpinner className="animate-spin text-2xl text-gray-600" />
            </div>
          ) : (
            <Table>
              <TableHeader className="border-b border-gray-300 sticky top-0 bg-white z-20">
                <TableRow>
                  <TableHeadCell>No</TableHeadCell>
                  <TableHeadCell>Date</TableHeadCell>
                  <TableHeadCell>ID</TableHeadCell>
                  <TableHeadCell>Customer Purchase Order</TableHeadCell>
                  <TableHeadCell>Customer Name</TableHeadCell>
                  <TableHeadCell>Delivery Date</TableHeadCell>
                  <TableHeadCell>Customer Item ID</TableHeadCell>
                  <TableHeadCell>Item Name</TableHeadCell>
                  <TableHeadCell>Status</TableHeadCell>
                  <TableHeadCell>Qty Sales Order</TableHeadCell>
                  <TableHeadCell>Production Plan Qty</TableHeadCell>
                  <TableHeadCell>Manufactured Qty</TableHeadCell>
                  <TableHeadCell>Delivery Qty</TableHeadCell>
                  <TableHeadCell>Return Qty</TableHeadCell>
                </TableRow>
              </TableHeader>

              <TableBody>
                {rowsData.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={13} className="text-center py-2 text-gray-500">
                      Tidak ada data
                    </TableCell>
                </TableRow>
                ) : (
                  rowsData.map(({ order, item, noItem }, idx) =>
                    noItem ? (
                      <TableRow key={`${order.name}-noitem`}>
                        <TableCell>-</TableCell>
                        <TableCell>{formatDate(order.transaction_date)}</TableCell>
                        <TableCell>{order.name}</TableCell>
                        <TableCell>{order.po_no || '-'}</TableCell>
                        <TableCell>{order.customer_name}</TableCell>
                        <TableCell>{formatDate(order.delivery_date)}</TableCell>
                        <TableCell colSpan={2}>No Item</TableCell>
                        <TableCell>
                          <div
                            style={getStatusStyle(order.status)}
                            className="p-2 rounded-[20px] inline-block text-xs"
                          >
                            {order.status}
                          </div>
                        </TableCell>
                        <TableCell colSpan={4}></TableCell>
                      </TableRow>
                    ) : (
                      <TableRow
                        key={`${order.name}-${item.item_code}-${idx}`}
                        // onClick={() => navigate(`/visualize-production-process/${order.name}`)}
                      >
                        <TableCell>{idx + 1}</TableCell>
                        <TableCell>{formatDate(order.transaction_date)}</TableCell>
                        <TableCell>{order.name}</TableCell>
                        <TableCell>{order.po_no || '-'}</TableCell>
                        <TableCell>{order.customer_name}</TableCell>
                        <TableCell>{formatDate(order.delivery_date)}</TableCell>
                        <TableCell>{item.custom_part_number_fg_customer || '-'}</TableCell>
                        <TableCell>{item.item_name}</TableCell>
                        <TableCell>
                          <div
                            style={getStatusStyle(order.status)}
                            className="p-2 rounded-[20px] inline-block text-sx"
                          >
                            {order.status}
                          </div>
                        </TableCell>
                        <TableCell>{item.qty.toLocaleString('id-ID')}</TableCell>
                        <TableCell>{item.production_plan_qty.toLocaleString('id-ID') || "-"}</TableCell>
                        <TableCell> {woSum[order.name]?.toLocaleString('id-ID') || "-"}</TableCell>
                        <TableCell>{item.delivered_qty.toLocaleString('id-ID') || "-"}</TableCell>
                        <TableCell>{item.returned_qty.toLocaleString('id-ID') || "-"}</TableCell>
                      </TableRow>
                    )
                  )
                )}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalesOrderList;
